// UTF-8

// こだわりスクロール（PC幅のみ）
const sections = document.querySelectorAll("[data-section]");
const lastSection = sections[sections.length - 1];
const lastInner = lastSection ? lastSection.querySelector("[data-section-inner]") : null;
const isPC = () => checkBreakpoint() === 'pc';

const initScrollTriggers = () => {
  sections.forEach((section) => {
    const inner = section.querySelector("[data-section-inner]");

    const setFixed = () => {
      gsap.set(inner, {
        position: "fixed",
        bottom: 0,
      });
    };

    const setAbsolute = () => {
      gsap.set(inner, {
        position: "absolute",
        bottom: "auto",
      });
    };

    ScrollTrigger.create({
      trigger: section,
      start: "bottom bottom",
      onEnter: setFixed,
      onEnterBack: setFixed,
      onLeave: setAbsolute,
      onLeaveBack: setAbsolute,
    });
  });
};

const resetStyles = () => {
  sections.forEach((section) => {
    const inner = section.querySelector("[data-section-inner]");
    if (inner) {
      gsap.set(inner, {
        clearProps: "all"
      });
    }
  });
};

// PC幅の場合のみScrollTriggerを初期化
if (isPC()) {
  initScrollTriggers();
}

// リサイズ時の処理（takumi_base.jsのリロード処理と連携）
let currentDevice = checkBreakpoint();
$(window).on('resize', function() {
  const newDevice = checkBreakpoint();
  if (currentDevice !== newDevice) {
    if (newDevice === 'pc') {
      // PC幅になった時
      initScrollTriggers();
    } else {
      // SP幅になった時：ScrollTriggerを全て削除してスタイルをリセット
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      resetStyles();
    }
    currentDevice = newDevice;
  }
});